import { useEffect, useRef } from 'react';
import { usePutReadMessage } from 'services/chat';
import { IChatMessage } from 'services/chat/types';

export const useReadMessages = (
  data: IChatMessage[] | undefined,
  recepientId: string | undefined,
  refetch?: () => void,
) => {
  const readMessage = usePutReadMessage();

  const processedIds = useRef(new Set());

  useEffect(() => {
    if (!data?.length) return;

    const unreadMessages = data.filter(
      msg => msg.recipientId === recepientId && msg.readAt === null,
    );

    const idsToSend = unreadMessages
      .map(msg => msg.id)
      .filter(id => !processedIds.current.has(id));

    if (idsToSend.length === 0) return;

    idsToSend.forEach(id => processedIds.current.add(id));

    Promise.all(
      idsToSend.map(id => readMessage.mutateAsync({ messageId: id })),
    ).then(() => refetch && refetch());
  }, [data, recepientId, readMessage.mutateAsync]);
};
